module.exports = __webpack_public_path__ + "static/media/team-member-03.7c212386.jpg";